import { useRepositoryQuery } from '@mews-commander/data-access';

export const useAccountSearch = () => {
    const useSearchQuery = (searchToken: string) => {
        const { data: customers, isFetching: isFetchingCustomers } = useRepositoryQuery('customers', 'search', {
            searchToken,
        });
        const { data: companies, isFetching: isFetchingCompanies } = useRepositoryQuery('companies', 'searchNew', {
            searchToken,
        });

        const isFetching = isFetchingCustomers || isFetchingCompanies;

        if (!searchToken.trim()) {
            return {
                isFetching,
                data: { customers: [], companies: [] },
            };
        }

        return {
            isFetching,
            data: {
                customers: customers ?? [],
                companies: companies?.companies ?? [],
            },
        };
    };

    return useSearchQuery;
};
